// extracted by mini-css-extract-plugin
module.exports =  {"seller-details":"Ev6jjWz","sellerDetails":"Ev6jjWz","seller-name":"y8gULvu","sellerName":"y8gULvu","badge":"QIRRtFf","promoted-gig-text":"rqaai1M","promotedGigText":"rqaai1M"};